export const SITE_URL = 'https://factorstreet.com';

export const globalSeoFallback = {
  siteName: 'FactorStreet',
  siteUrl: SITE_URL,
  defaultMetaTitleFormat: '{{title}} | FactorStreet',
  defaultMetaDescription:
    'FactorStreet is a technology and education company building SaaS products, digital platforms, education brands, web applications, and scalable online business systems.',
  defaultMetaKeywords:
    'factorstreet, technology company india, education technology company, saas product company, digital product company, software product company, web application development company, online education platform',
  defaultOpenGraphImageUrl: '',
  defaultTwitterCardType: 'summary_large_image',
  globalRobotsDefault: 'index, follow',
};

export const pageSeoFallbacks = [
  {
    pageKey: 'home',
    label: 'Home',
    path: '/',
    metaTitle: 'FactorStreet | Technology & Education Company Building Digital Products',
    metaDescription:
      'FactorStreet builds SaaS products, education platforms, web applications, and digital business systems across DevX Factor, SatyamCode, PhysicsFactor, and SatyamSir.',
    metaKeywords:
      'technology company india, education technology company, saas product company, digital product company, factorstreet',
  },
  {
    pageKey: 'about',
    label: 'About',
    path: '/about',
    metaTitle: 'About FactorStreet | Technology & Education Company',
    metaDescription:
      'Learn about FactorStreet, a founder-led company building digital products, education platforms, SaaS systems, and scalable online business initiatives.',
    metaKeywords: 'about factorstreet, technology and education company, digital product company, education startup india',
  },
  {
    pageKey: 'devxfactor',
    label: 'DevX Factor',
    path: '/services/devxfactor',
    metaTitle: 'DevX Factor | SaaS Project Planning Platform by FactorStreet',
    metaDescription:
      'DevX Factor helps founders, agencies, developers, and students convert project ideas into structured requirements, proposal PDFs, invoices, and AI software blueprints.',
    metaKeywords:
      'devx factor, ai software blueprint generator, project requirement gathering software, proposal pdf generator',
  },
  {
    pageKey: 'satyamcode',
    label: 'SatyamCode',
    path: '/services/satyamcode',
    metaTitle: 'SatyamCode | Full-Stack Development Ecosystem by FactorStreet',
    metaDescription:
      'SatyamCode is a full-stack development and resource ecosystem focused on MERN applications, CMS systems, dashboards, and business workflow development.',
    metaKeywords: 'satyamcode, full stack developer, mern developer, web application development',
  },
  {
    pageKey: 'physicsfactor',
    label: 'PhysicsFactor',
    path: '/services/physicsfactor',
    metaTitle: 'PhysicsFactor | Physics Learning Platform by FactorStreet',
    metaDescription:
      'PhysicsFactor provides structured physics theory, concept-building questions, detailed solutions, and chapter-wise tests for boards, NEET, and IIT JEE students.',
    metaKeywords:
      'physicsfactor, physics questions and solutions, neet physics questions, iit jee physics practice, cbse physics resources',
  },
  {
    pageKey: 'satyamsir',
    label: 'SatyamSir',
    path: '/services/satyamsir',
    metaTitle: 'SatyamSir | Personal Physics Tutoring Brand by FactorStreet',
    metaDescription:
      'SatyamSir offers personal physics mentoring, concept clarity, numerical practice, doubt solving, and exam-focused guidance for JEE, NEET, and board students.',
    metaKeywords: 'satyamsir, online physics tutor, iit jee physics tutor, neet physics tutor, personal physics mentoring',
  },
  {
    pageKey: 'jobs',
    label: 'Jobs',
    path: '/jobs',
    metaTitle: 'Current Openings | Careers at FactorStreet',
    metaDescription:
      'Explore current job openings at FactorStreet across technology, education, operations, sales, marketing, and management roles.',
    metaKeywords: 'factorstreet jobs, factorstreet careers, startup jobs, technology jobs, education jobs',
  },
  {
    pageKey: 'hiring-process',
    label: 'Hiring Process',
    path: '/hiring-process',
    metaTitle: 'Hiring Process | FactorStreet Careers',
    metaDescription:
      "Understand FactorStreet's hiring process including application form, group interview, paid task round, and final personal interview.",
    metaKeywords: 'factorstreet hiring process, job application process, startup hiring process, paid task round',
  },
  {
    pageKey: 'apply',
    label: 'Apply',
    path: '/apply',
    metaTitle: 'Apply Now | FactorStreet Careers',
    metaDescription:
      'Submit your job application to FactorStreet for current and future roles across technology, education, management, sales, marketing, and operations.',
    metaKeywords: 'apply factorstreet, factorstreet job application, startup job application, career application',
  },
  {
    pageKey: 'apply-thank-you',
    label: 'Application Submitted',
    path: '/apply/thank-you',
    metaTitle: 'Application Submitted | FactorStreet Careers',
    metaDescription:
      'Thank you for applying to FactorStreet. Your job application has been received and our hiring team will review your details.',
    metaKeywords: '',
    robots: 'noindex, nofollow',
  },
  {
    pageKey: 'complete-task',
    label: 'Task Completion Form',
    path: '/complete-task',
    metaTitle: 'Task Completion Form | FactorStreet Careers',
    metaDescription:
      'Selected FactorStreet candidates can submit their paid task round work through this private task completion form.',
    metaKeywords: '',
    robots: 'noindex, nofollow',
  },
  {
    pageKey: 'complete-task-thank-you',
    label: 'Task Submitted',
    path: '/complete-task/thank-you',
    metaTitle: 'Task Submitted | FactorStreet Careers',
    metaDescription:
      'Thank you for completing the FactorStreet task round. Our hiring team will review your submission.',
    metaKeywords: '',
    robots: 'noindex, nofollow',
  },
  {
    pageKey: 'contact',
    label: 'Contact',
    path: '/contact',
    metaTitle: 'Contact FactorStreet | Business, Jobs & Collaboration',
    metaDescription:
      'Contact FactorStreet for business inquiries, service discussions, hiring questions, investment interest, and collaboration opportunities.',
    metaKeywords: 'contact factorstreet, factorstreet enquiry, business collaboration, startup contact',
  },
  {
    pageKey: 'about-ceo',
    label: 'About CEO',
    path: '/about-ceo',
    metaTitle: 'About CEO | Satyam Kumar, Founder of FactorStreet',
    metaDescription:
      'Learn about Satyam Kumar, Founder and CEO of FactorStreet, and his work across technology, education, digital products, and full-stack development.',
    metaKeywords: 'satyam kumar, factorstreet founder, factorstreet ceo, satyam sir',
  },
  {
    pageKey: 'upcoming-projects',
    label: 'Upcoming Projects',
    path: '/upcoming-projects',
    metaTitle: 'Upcoming Projects | FactorStreet',
    metaDescription:
      'Explore upcoming FactorStreet initiatives across technology products, education platforms, digital systems, and business development.',
    metaKeywords: 'factorstreet upcoming projects, digital products, education platforms, technology initiatives',
  },
];

export function normalizeSeoPath(pathname) {
  const path = pathname || '/';
  return path.length > 1 ? path.replace(/\/+$/g, '') : '/';
}

export function buildCanonicalUrl(pathname, siteUrl = SITE_URL) {
  const path = normalizeSeoPath(pathname);
  const baseUrl = String(siteUrl || SITE_URL).replace(/\/+$/g, '');
  return path === '/' ? `${baseUrl}/` : `${baseUrl}${path}`;
}

export function getFallbackSeo(pathname) {
  const path = normalizeSeoPath(pathname);
  const page =
    pageSeoFallbacks.find((item) => item.path === path) ||
    (path.startsWith('/jobs/') && {
      pageKey: 'job-detail',
      label: 'Job Detail',
      path,
      metaTitle: 'Job Opening | FactorStreet Careers',
      metaDescription: 'Explore this published FactorStreet job opening and apply through the official careers flow.',
      metaKeywords: 'factorstreet careers, factorstreet jobs, startup jobs',
    }) ||
    {
      pageKey: 'fallback',
      label: 'FactorStreet',
      path,
      metaTitle: 'FactorStreet | Technology & Education Company',
      metaDescription: globalSeoFallback.defaultMetaDescription,
      metaKeywords: globalSeoFallback.defaultMetaKeywords,
    };

  const canonicalUrl = buildCanonicalUrl(path, globalSeoFallback.siteUrl);

  return {
    global: globalSeoFallback,
    page: {
      ...page,
      canonicalUrl,
      robots:
        page.robots ||
        (path.startsWith('/admin') ? 'noindex, nofollow' : globalSeoFallback.globalRobotsDefault),
      openGraph: {
        title: page.openGraphTitle || page.metaTitle,
        description: page.openGraphDescription || page.metaDescription,
        type: 'website',
        url: canonicalUrl,
        image: page.openGraphImageUrl || '',
      },
      twitter: {
        card: globalSeoFallback.defaultTwitterCardType,
        title: page.openGraphTitle || page.metaTitle,
        description: page.openGraphDescription || page.metaDescription,
        image: page.openGraphImageUrl || '',
      },
    },
  };
}
